import { Module } from "./module-enum";

export class SpargingCalibration {
  deviceId: number;
  name: string;
  saveLocationName: string;
  volume?: number;
  // Final sparging cal fields
  slope_A?: number;
  slope_B?: number;
  slope_C?: number;
  slope_D?: number;
  intercept_A?: number;
  intercept_B?: number;
  intercept_C?: number;
  intercept_D?: number;
  r2_A?: number;
  r2_B?: number;
  r2_C?: number;
  r2_D?: number;
  id?: number;
  isFinal?: boolean;
  laboratoryId?: number;
  createdAt?: Date;
  isDeleted?: boolean;
  deviceName?: string;
  calibrationType?: Module;
  notes?: string;

  constructor(
    deviceId: number,
    name: string,
    saveLocationName: string,
    volume?: number,
    slope_A?: number,
    slope_B?: number,
    slope_C?: number,
    slope_D?: number,
    intercept_A?: number,
    intercept_B?: number,
    intercept_C?: number,
    intercept_D?: number,
    r2_A?: number,
    r2_B?: number,
    r2_C?: number,
    r2_D?: number,
    id?: number,
  ) {
    this.deviceId = deviceId;
    this.name = name;
    this.saveLocationName = saveLocationName;
    this.volume = volume;
    this.slope_A = slope_A;
    this.slope_B = slope_B;
    this.slope_C = slope_C;
    this.slope_D = slope_D;
    this.intercept_A = intercept_A;
    this.intercept_B = intercept_B;
    this.intercept_C = intercept_C;
    this.intercept_D = intercept_D;
    this.r2_A = r2_A;
    this.r2_B = r2_B;
    this.r2_C = r2_C;
    this.r2_D = r2_D;
    this.id = id;
  }
}

export class SpargingCalibrationUpdate {
  name: string;
  slope_A?: number;
  slope_B?: number;
  slope_C?: number;
  slope_D?: number;
  intercept_A?: number;
  intercept_B?: number;
  intercept_C?: number;
  intercept_D?: number;
  r2_A?: number;
  r2_B?: number;
  r2_C?: number;
  r2_D?: number;
  id?: number;
  notes?: string;

  constructor(
    name: string,
    slope_A?: number,
    slope_B?: number,
    slope_C?: number,
    slope_D?: number,
    intercept_A?: number,
    intercept_B?: number,
    intercept_C?: number,
    intercept_D?: number,
    r2_A?: number,
    r2_B?: number,
    r2_C?: number,
    r2_D?: number,
    id?: number,
    notes?: string,
  ) {
    this.name = name;
    this.slope_A = slope_A;
    this.slope_B = slope_B;
    this.slope_C = slope_C;
    this.slope_D = slope_D;
    this.intercept_A = intercept_A;
    this.intercept_B = intercept_B;
    this.intercept_C = intercept_C;
    this.intercept_D = intercept_D;
    this.r2_A = r2_A;
    this.r2_B = r2_B;
    this.r2_C = r2_C;
    this.r2_D = r2_D;
    this.id = id;
    this.notes = notes;
  }
}
